// export { PARTS_INVENTORY_ADJUSTMENTS as NAME } from '../constants';
export const DMS_MODULE = 'Nd';
export const CRUMB_LABEL_KEY = 'BulkInventoryApproval';
export const NAME = 'BulkInventoryApproval';
export const PENDING_STATUS = 0;
export const APPROVE = 1;
export const REJECT = 2;
export const DMS3_INFO_TITLE = 'DMS3_InfoTitle';
export const INVALID_FORM = 'Invalid_Form';
export const DEPENDENT_TABLES_ALL = <const>[];
export const CONFIRM = 'confirm';
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];

export enum RequestStatus {
	APPROVED = 1,
	PENDING = 2,
	REJECTED = 3
}
